// @see http://opurs.hz.netease.com/docDetail.html?pid=387#/

const ursCssPath = '/common-styles/urs/'
const { origin } = window.location
const originAsHttps = origin.replace('http://', 'https://')
const ursCssDomain = `${originAsHttps}${ursCssPath}`

const ursConfig = {
  newCDN: 1, // 必须，代表使用的CDN是连通性更好的SNI域名
  version: 4, // 必须，代表版本4
  cssDomain: ursCssDomain, //可选，产品自定义css的域名https://a.b.com，注意css的协议，必须是https协议
  product: 'youdao_zhiyun2018', // 必须，产品ID,下面有测试值
  promark: 'JXZpLHp', // 必须，组件ID,下面有测试值
  host: 'ai.youdao.com', // 必须，工单申请的值
  productKey: '108ab9ba5c844f6196682233cc199546',
  isHttps: 1, // 必填1
  cookieDomain: 'youdao.com', //必须
  regCookieDomain: 'youdao.com', //必须
  needEye: 1, //密码框是否需要眼睛默认此节点是隐藏的，打开功能的请配合css
  frameSize: { width: '420', height: '333' },
  // regUrlForce:
  //   'http://zc.reg.163.com/regInitialized?pd=xxx&pkid=xxx&pkht=x%E2%80%99#/', //必须,如果产品需要引导统一注册页，必须先申请web组件统一注册页
}

const mobileService = [
  {
    name: '《服务条款》',
    url: 'https://ai.youdao.com/clause.html',
  },
  {
    name: '《有道隐私政策》',
    // url: 'https://reg.163.com/agreement_mobile_ysbh_wap.shtml?v=20171127',
    url:
      'https://ai.youdao.com/DOCSIRMA/html/agreement/privacy/ydyszc/index.html',
  },
]

export { ursConfig, mobileService }
